export default __webpack_public_path__ + "static/media/doe_run.6a5036b0.png";